import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/lib/AdAlliance/AdAlliance.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/lib/AdDefend/AdDefend.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/lib/GoogleTagManager/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/lib/NetID/NetID.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/lib/Outbrain/Outbrain.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/lib/Sourcepoint/ConsentContext.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/lib/Sourcepoint/Sourcepoint.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/Embed/Embed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/Tickaroo/Tickaroo.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/group/grid/combi-ad/combi-ad.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/group/group-grid/viewport/viewport.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/ReactComment.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/autonative/default/default.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/epg/longform/longform.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/epg/rtl-plus-event/rtl-plus-event.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/iframe/default/default.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/integration/default/default.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/login/default/default.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/menu/bannerNavigation/bannerNavigation.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/menu/seobox/seobox.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/satisfaction-survey/default/default.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/series/authors/placeholder.webp");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/tagpage/index-default/index-default.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/playlist/playlist.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/rtl-plus-letzte-folgen/rtl-plus-letzte-folgen.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/search/search.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/tools-calculator/allergy-test/allergy-test.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/tools-calculator/biological-age/biological-age.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/tools-calculator/bmi-children/bmi-children.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/tools-calculator/bmi/bmi.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/tools-calculator/date-of-birth/date-of-birth.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/tools-calculator/love-oracle/love-oracle.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/tools-calculator/name-oracle/name-oracle.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/video/detail/detail.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/video/with-related/with-related.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/UI/Accordion/Accordion.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/AdSlot/AdSlot.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/AdSlot/AdSlot.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/DropdownMenu/DropdownMenu.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/EpgDateNavigation/EpgDateNavigation.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/EpgItem/EpgItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/UI/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/UI/FoundationPlayer/FoundationPlayer.client.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Gallery/Gallery.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Header/Header.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Icon/CloseIcon.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Image/Image.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Link/Link.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Button/Button.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/UI/Pagination/Pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/UI/Pagination/TagpagePagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/UI/Pills/Pills.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/ReadMoreSection/ReadMoreSection.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/ScrollTrackWrapper/ScrollTrackWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/SearchBar/SearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/UI/Swiper/Swiper.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Teaser/Teaser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/publishing/rtlde/frontend/components/UI/TeaserGridSection/TeaserGridSection.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/TeaserSearch/TeaserSearch.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/AdInsideList/AdInsideList.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Breadcrumb/Breadcrumb.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/text/text.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/FallbackImage/FallbackImage.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/rtl-plus-top5/rtl-plus-top5.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/small-with-medium/small-with-medium.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/rtl-plus/rtl-plus.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/NewsTicker/NewsTicker.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Title/Title.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/news-ticker/news-ticker.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Episode/Episode.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/rtl-plus-ganze-folgen/rtl-plus-ganze-folgen.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/FoundationPlayer/FoundationPlayer.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/highlight/highlight.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/teaser/banner/banner.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/topic-page-links/default/default.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/typography/gallery/gallery.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/MarketingEmbed/MarketingEmbed.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/storyline-date-and-author/default/default.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/seolinks/default/default.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/series/menu/menu.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/series/default/default.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/series/authors/authors.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/series/list/list.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/search/block/block.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/picture/full/full.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/group/grid/auto-fill/auto-fill.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/menu/footer/footer.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/menu/default/default.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/integration/tv-lottery-answers/tv-lottery-answers.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Heading/Heading.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/epg/episodes-preview/episodes-preview.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/epg/default/default.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/article-detail/gallery/gallery.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/SponsoredIcon/SponsoredIcon.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/article-detail/head/head.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/AnnotatedMarkup/AnnotatedMarkup.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/BulletedList/BulletedList.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/Faq/Faq.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/Html/Html.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/LeadText/LeadText.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/NumberedList/NumberedList.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/PersonalData/PersonalData.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/Picture/Picture.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/RtlPlusContent/RtlPlusContent.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/StorylineDefaultType.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/storyline-elements/Video/Video.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/widget/article-detail/author/author.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/group/grid/topic/topic.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/group/grid/persona/persona.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/group/grid/fixed-sidebar/fixed-sidebar.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/group/grid/section/section.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/group/grid/default/default.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/group/grid/2-1/2-1.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/partials/article/index/index.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Loader/Loader.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/SponsoredHeader/SponsoredHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/components/UI/Layout/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/builds/publishing/rtlde/frontend/context/providers.tsx");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/node_modules/next/font/local/target.css?{\"path\":\"utils/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../assets/fonts/rtl-united-regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../assets/fonts/rtl-united-bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"}]}],\"variableName\":\"fontRtlUnited\"}");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/builds/publishing/rtlde/frontend/utils/ErrorBoundary.tsx");
